import { App, StrykerAlertColor } from 'osep-react-antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import LogoutButton from './LogoutButton';
import { Button, Divider, notification } from 'antd';
import { useMsal } from '@azure/msal-react';
import ConnectionButton from '../connections/ConnectionButton';
import { PROVIDERS } from '../connections/providers';
import { useConnectionsQuery } from '../../hooks/query/useConnectionsQuery';
import { useOAuthFlowResult } from '../../hooks/useOAuthFlowResult';

interface Props {
  children: React.ReactNode;
  searchTerm?: string;
  selectedGroup?: string | null;
}

const AppLayout: React.FC<Props> = ({ children }) => {
  const { accounts } = useMsal();
  const [api, notificationHolder] = notification.useNotification();
  const { data: connections } = useConnectionsQuery();

  const navigate = useNavigate();

  useOAuthFlowResult({
    onConnected: () =>
      api.success({
        message: 'Connected',
        description: 'The account is connected for every OSEP app.',
      }),
    onError: (description) =>
      api.error({ message: 'Connection failed', description }),
  });

  const gitlabConnected = !connections || !!connections.gitlab;

  return (
    <App
      title="Generator"
      logo="osep"
      onLogoClick={() => navigate('/')}
      onTitleClick={() => navigate('/')}
      userStatusColor={
        gitlabConnected ? StrykerAlertColor.SUCCESS : StrykerAlertColor.ERROR
      }
      userMenu={
        <div>
          <p style={{ margin: 0 }}>Logged in as</p>
          <p style={{ marginTop: 0, fontWeight: 'bold' }}>
            {accounts[0].username}
          </p>
          <p>
            <LogoutButton />
          </p>
          {(Object.keys(PROVIDERS) as (keyof typeof PROVIDERS)[]).map(
            (provider) => (
              <p key={provider}>
                <ConnectionButton provider={provider} />
              </p>
            ),
          )}
          <Divider />
          <p>
            <Button
              type="primary"
              block
              onClick={() => {
                navigate(`/presets`);
              }}
            >
              Presets
            </Button>
          </p>
        </div>
      }
    >
      {notificationHolder}
      {children}
    </App>
  );
};

export default AppLayout;
